import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';
import loc, { format } from 'owa-localize';
import { lazyShowNotification } from 'owa-notification-bar';
import { moveItemFailedNotification } from './showNotificationOnMoveFailure.locstring.json';

/**
 * This method shows notification when shared folder move action fails
 * @param destinationFolderId - destination folderId for which move items action failed
 */
export default function showNotificationOnMoveFailure(destinationFolderId: string) {
    const destinationFolderName = getEffectiveFolderDisplayName(
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (15,9): Argument of type 'MailFolder | undefined' is not assignable to parameter of type 'Pick<MailFolder, "remoteFolderInfo" | "displayName">'.
        // @ts-expect-error
        folderStore.folderTable.get(destinationFolderId)
    );
    lazyShowNotification.importAndExecute(
        'moveSharedFolderItems',
        'MailModuleNotificationBarHost',
        format(loc(moveItemFailedNotification), destinationFolderName)
    );
}
